import { createActionTypeModel } from "../../../../store/global/action-model";

export const DistributionOrderList=createActionTypeModel('DistributionOrderList');

export const DistributionOrderDetails = createActionTypeModel('DistributionOrderDetails');

export const DistributionOrderInvoiceContact=createActionTypeModel('DistributionOrderInvoiceContact');


export const DistributionOrderDeliveryAddress = createActionTypeModel('DistributionOrderDeliveryAddress');

export const DistributionOrderBackOrder = createActionTypeModel('DistributionOrderBackOrder');

export const DistributionOrderOrderLine = createActionTypeModel('DistributionOrderOrderLine');

export const DistributionPackageLine = createActionTypeModel('DistributionPackageLine');

export const DistributionShippingSummary = createActionTypeModel('DistributionShippingSummary');

export const INVOICE_CONTACT = createActionTypeModel('INVOICE_CONTACT');
export const ORDER_LINES = createActionTypeModel('ORDER_LINES');
export const BACKORDERS = createActionTypeModel('BACKORDERS');
export const SEARCH_ORDER = 'SEARCH_ORDER';
export const SELECTED_ORDER = createActionTypeModel('SELECTED_ORDER');
export const SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';
export const DELETE_ORDER = 'DELETE_ORDER';

export const FETCH_ORDER_TAB_DATA = 'FETCH_ORDER_TAB_DATA';
export const SET_ORDER_TAB_DATA = 'SET_ORDER_TAB_DATA';

export const GET_SELECTED_ORDER_DATA = 'GET_SELECTED_ORDER_DATA';
export const FETCH_SELECTED_ORDER_DATA = 'FETCH_SELECTED_ORDER_DATA';
export const SET_SELECTED_ORDER_DATA = 'SET_SELECTED_ORDER_DATA';
export const CLEAR_SELECTED_ORDER_DATA = 'CLEAR_SELECTED_ORDER_DATA';
export const UPDATE_SELECTED_ORDER_DATA='UPDATE_SELECTED_ORDER_DATA';


//overview tab //

export const FETCH_ORDER_DETAILS_TAB_OVERVIEW_BY_ORDERID='FETCH_ORDER_DETAILS_TAB_OVERVIEW';
export const SET_ORDER_DETAILS_TAB_OVERVIEW='SET_ORDER_DETAILS_TAB_OVERVIEW';
export const GET_DELIVERY_ADDRESS_BY_ORDERID='GET_DELIVERY_ADDRESS_BY_ORDERID';

//backorders tab//
export const FETCH_ORDER_DETAILS_TAB_BACKORDERS_BY_ORDERID='FETCH_ORDER_DETAILS_TAB_BACKORDERS_BY_ORDERID';
export const SET_ORDER_DETAILS_TAB_BACKORDERS='SET_ORDER_DETAILS_TAB_BACKORDERS';
export const GET_BACKORDERS_BY_ORDERID='GET_BACKORDERS_BY_ORDERID';

//orderlines tab//

export const FETCH_ORDER_DETAILS_TAB_ORDERLINES_BY_ORDERID='FETCH_ORDER_DETAILS_TAB_ORDERLINES_BY_ORDERID';
export const SET_ORDER_DETAILS_TAB_ORDERLINES='SET_ORDER_DETAILS_TAB_ORDERLINES';
export const GET_ORDERLINES_BY_ORDERID='GET_ORDERLINES_BY_ORDERID';
export const FETCH_ORDERLINES_FROM_DATA='FETCH_ORDERLINES_FROM_DATA';
export const SET_ORDERLINES_FROM_DATA='SET_ORDERLINES_FROM_DATA';
export const FETCH_ORDER_PRODUCTS='FETCH_ORDER_PRODUCTS';
export const SET_ORDER_PRODUCTS='SET_ORDER_PRODUCTS';
//packing and shipping//

export const FETCH_ORDER_DETAILS_TAB_PACKING_AND_SHIPPING_BY_ORDERID='FETCH_ORDER_DETAILS_TAB_PACKING_AND_SHIPPING_BY_ORDERID';
export const SET_ORDER_DETAILS_TAB_PACKING_AND_SHIPPING='SET_ORDER_DETAILS_TAB_PACKING_AND_SHIPPING';
export const GET_PACKING_ORDERLINES_BY_ORDERID='GET_PACKING_ORDERLINES_BY_ORDERID';

//summary //
export const FETCH_ORDER_DETAILS_TAB_SUMMARY_BY_ORDERID='FETCH_ORDER_DETAILS_TAB_SUMMARY_BY_ORDERID';
export const SET_ORDER_DETAILS_TAB_SUMMARY='SET_ORDER_DETAILS_TAB_SUMMARY';

//MUlti orders//

export const SET_MULTI_ORDER_DATA = 'SET_MULTI_ORDER_DATA';
export const FETCH_MULTI_ORDER_DATA = 'FETCH_MULTI_ORDER_DATA';
export const FETCH_FILTERED_MULTI_ORDER_DATA = 'FETCH_FILTERED_MULTI_ORDER_DATA';
export const SET_FILTERED_MULTI_ORDER_DATA='SET_FILTERED_MULTI_ORDER_DATA';
export const INSERT_MULTI_ORDER_DATA = 'INSERT_MULTI_ORDER_DATA';

//delivery info//
export const UPDATE_ORDER_DELIVERY_INFO = 'UPDATE_ORDER_DELIVERY_INFO';


